<template>
    <div class="article-about-us">
        <p>
            GSC Editorial is an international copywriting agency committed to create sports and casino content. Our
            specialist writers have decades of experience creating fresh, informative and engaging content for
            international gaming and sports brands. Our journey began in 2009 and since then we have been writing
            search-engine-friendly content for our clients’ websites.
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleAboutUs',
};
</script>
